import Accordion from 'accordion-js';

class HeroBanner extends HTMLElement {
  constructor() {
    super();

    this.isCollapsible = (this.getAttribute('is-collapsible') === 'true');
  }

  connectedCallback() {
    const mq = window.matchMedia('(max-width: 640px)');

    if (!this.isCollapsible || !mq.matches) {
      return;
    }

    const accordionContainer = this.closest('.section');

    new Accordion(accordionContainer, {
      elementClass: 'section__inner',
      triggerClass: 'hero__collapse-trigger',
      panelClass: 'hero',
      duration: 200,
      showMultiple: true,
      beforeOpen: (currentElement) => {
        currentElement.querySelector('span').classList.add('is-active');
      },
      beforeClose: (currentElement) => {
        currentElement.querySelector('span').classList.remove('is-active');
      },
    });
  }
}

customElements.define('hero-banner', HeroBanner);

export default HeroBanner;
